var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../styled';
import { PageContext } from './page-context';
export var PageComponentName = 'QuantumPage';
var Root = styled('div', { name: 'QuantumPage' })(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'grid',
        gridGap: theme.spacing(5),
        gridTemplateColumns: '1fr',
        flex: 1,
    });
});
export var Page = React.forwardRef(function (props, ref) {
    var _a = props.fullWidth, fullWidth = _a === void 0 ? false : _a, _b = props.compact, compact = _b === void 0 ? false : _b, children = props.children, rootProps = __rest(props, ["fullWidth", "compact", "children"]);
    return (React.createElement(PageContext.Provider, { value: { fullWidth: fullWidth, compact: compact } },
        React.createElement(Root, __assign({}, rootProps, { ref: ref }), children)));
});
